import { render } from "./WorkItem.vue?vue&type=template&id=e87abb00&scoped=true&ts=true"
import script from "./WorkItem.vue?vue&type=script&lang=ts"
export * from "./WorkItem.vue?vue&type=script&lang=ts"

import "@/components/SelectedWork/WorkItem/style.scss?vue&type=style&index=0&id=e87abb00&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e87abb00"]])

export default __exports__